import React, { useMemo } from 'react';
import parse from 'html-react-parser';
import { sanitizeHtml } from '../../helpers/sanitizeHtml';

const SanitizedRichText = ({ html, className = '' }) => {
  const safeHtml = useMemo(() => sanitizeHtml(html), [html]);
  const cleaned = useMemo(
    () => (safeHtml || '').replace(/contenteditable="false"/g, ''),
    [safeHtml]
  );

  return <div className={className}>{parse(cleaned)}</div>;
};

export default SanitizedRichText;
